import React from 'react'
import { Link } from 'react-router-dom'

export const SecondSection = () => {
    
  return (
    <>
    <section className="secondSection">
        <div className="container">
            <div className='row align-items-center'>
                <div className='col-lg-6 col-md-12 col-sm-12'>
                    <div className='secondSectionLeft'>
                        <img style={{objectFit:'contain',width:'100%'}} src={require("../assets/images/vtvSolarenergy.jpg")} alt='residential solar panel installation' />
                    </div>
                </div>
                <div className='col-lg-6 col-md-12 col-sm-12'>
                    <div className='secondSectionRight'>
                        <h2 className='text-white'>VTV Energy</h2>
                        <p className='text-white'>
                        {/* VTV Energy is Connecticut's #1 choice for residential and commercial solar installations. VTV Solar is a family-owned business, based in Hamden, Connecticut. VTV Solar operates in all 50 states and US territories. What we offer: VTV Energy offers the latest technologies for residential and commercial solar installations. */}
                        VTV Energy is a family-owned business. We operate in all 50 states and US territories. Why VTV Energy Our values match yours. Our vision of leave an everlasting positive impact through the energy industry will support you, your kids, your grandchildren, and many generations after. We believe in people and the good in the world. Join the right side of history. Join VTV.
                            </p>
                        <Link to="/Why-VTV"><button className='btnSecondSec'>Learn More</button></Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
